import { API_CONFIG, apiUtils } from '../config.js';

/**
 * WhatsApp Configuration API Service
 * Handles CRUD operations for WhatsApp Business API credentials
 */
export const whatsappConfigApi = {
  /**
   * Validate WhatsApp credentials before saving
   * @param {string} phoneNumberId - WhatsApp Business Phone Number ID
   * @param {string} whatsappToken - WhatsApp Access Token
   * @returns {Promise<{success: boolean, message: string, data: {isValid: boolean}}>}
   */
  validateCredentials: async (phoneNumberId, whatsappToken) => {
    const url = `${API_CONFIG.BASE_URL}/whatsapp/config/validate`;
    return apiUtils.makeAuthenticatedRequest(url, {
      method: 'POST',
      body: JSON.stringify({
        phoneNumberId,
        whatsappToken,
      }),
    });
  },

  /**
   * Save WhatsApp configuration
   * @param {Object} configData - Configuration data
   * @param {string} configData.phoneNumberId - WhatsApp Business Phone Number ID (required)
   * @param {string} configData.whatsappToken - WhatsApp Access Token (required)
   * @param {string} [configData.verifyToken] - Custom token for webhook verification (optional)
   * @param {string} [configData.webhookUrl] - Webhook endpoint URL (optional)
   * @returns {Promise<{success: boolean, message: string, data: Object}>}
   */
  saveConfiguration: async (configData) => {
    const url = `${API_CONFIG.BASE_URL}/whatsapp/config`;
    return apiUtils.makeAuthenticatedRequest(url, {
      method: 'POST',
      body: JSON.stringify(configData),
    });
  },

  /**
   * Get current WhatsApp configuration
   * Note: Access token is never returned for security reasons
   * @returns {Promise<{success: boolean, message: string, data: Object}>}
   */
  getConfiguration: async () => {
    const url = `${API_CONFIG.BASE_URL}/whatsapp/config`;
    return apiUtils.makeAuthenticatedRequest(url, {
      method: 'GET',
    });
  },

  /**
   * Delete/Deactivate WhatsApp configuration
   * @returns {Promise<{success: boolean, message: string}>}
   */
  deleteConfiguration: async () => {
    const url = `${API_CONFIG.BASE_URL}/whatsapp/config`;
    return apiUtils.makeAuthenticatedRequest(url, {
      method: 'DELETE',
    });
  },
};

export default whatsappConfigApi;
